module.exports = __webpack_public_path__ + "static/media/clipboard-user.ff6eea89.svg";